export enum SpinnerSize {
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large"
}
